import React from 'react';
import styled from 'styled-components';

const Loader = ({ label = 'Chargement' }) => (
  <Wrapper role="status" aria-live="polite" aria-label={label}>
    <Wordmark viewBox="0 0 138 76" aria-hidden="true">
      <text className="stroke letter-p" x="18" y="43">P</text>
      <text className="stroke letter-b" x="58" y="66">B</text>
      <circle className="dot" cx="116" cy="18" r="3.6" />
    </Wordmark>
    <Caption>{label}</Caption>
  </Wrapper>
);

const Wrapper = styled.div`
  display: inline-grid;
  justify-items: center;
  gap: .7rem;
`;

const Wordmark = styled.svg`
  width: min(8rem, 40vw);
  height: auto;
  overflow: visible;

  .stroke {
    fill: transparent;
    stroke: #111;
    stroke-width: 1.25;
    stroke-linejoin: round;
    stroke-linecap: round;
    paint-order: stroke fill;
    font-family: "Manrope", Inter, Arial, sans-serif;
    font-size: 52px;
    font-weight: 800;
    letter-spacing: -5px;
    stroke-dasharray: 210;
    stroke-dashoffset: 210;
    animation: draw 1.5s cubic-bezier(.55, 0, .25, 1) infinite;
  }

  .letter-b {
    animation-delay: .16s;
  }

  .dot {
    fill: #111;
    opacity: 0;
    transform-origin: 116px 18px;
    animation: pulse 1.5s ease infinite;
  }

  @keyframes draw {
    0% {
      stroke-dashoffset: 210;
      fill: rgba(17, 17, 17, 0);
      opacity: .55;
      transform: translateY(6px);
    }
    26%, 74% {
      stroke-dashoffset: 0;
      fill: rgba(17, 17, 17, 1);
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      stroke-dashoffset: -210;
      fill: rgba(17, 17, 17, 0);
      opacity: .22;
      transform: translateY(-4px);
    }
  }

  @keyframes pulse {
    0%, 50% { opacity: 0; transform: scale(.2); }
    62%, 78% { opacity: 1; transform: scale(1); }
    100% { opacity: 0; transform: scale(1.8); }
  }

  @media (prefers-reduced-motion: reduce) {
    .stroke,
    .dot {
      animation: none;
      stroke-dashoffset: 0;
      opacity: 1;
      fill: #111;
      transform: none;
    }
  }
`;

const Caption = styled.span`
  color: var(--color-muted);
  font-size: .78rem;
  font-weight: 750;
  letter-spacing: .02em;
`;

export default Loader;
